module.exports = __webpack_public_path__ + "static/media/scaleH-icon.30a0e6d2.svg";